<template>
  <div>
    <loading-dialog :text="loadingText" :loading-dialog-show="transferLoadingCardShow"
                    @closeLoadingDialog="closeLoadingDialog"></loading-dialog>
    <v-dialog v-model="transferFileDialogShow" persistent width="40%" height="40%">
      <v-card>
        <v-card-title style="box-shadow: 0 2px 7px 0 #A6A6A63F;font-size: 20px;" class="alibabaPuHuiTiFontFamily">
          <p style="color: black">团队文件生成</p>
          <v-spacer></v-spacer>
          <p @click="closeTransferDialog" style="float:right;font-size:14px;color:#A6A6A6;cursor:pointer;"
             class="iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text class="pa-0">
          <div class="px-7 py-3" style="width: 100%;overflow: scroll" :style="{'height': 'px'}">
            <div style="height: 80px">
              <div style="display: flex;height: 68px;width:100%;line-height: 80px;color: black">
                <v-radio-group v-model="fileType" row>
                  <v-radio class="disable-checkbox" disabled :value="0" style="color: rgba(166,166,166,1)">
                    <template v-slot:label>
                      <span style="color: rgba(166,166,166,1);margin-top: 2px">个人文件</span>
                    </template>
                  </v-radio>
                  <v-radio style="margin-left: 100px" :value="1">
                    <template v-slot:label>
                      <span style="color: black;margin-top: 2px">团队文件</span><span class="new-icon">NEW</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>
            </div>
            <div style="display: flex;">
              <p style="color: black;font-size: 16px;">文件名</p>
              <v-text-field v-model="tempFileName"
                            dense outlined
                            class="filename-input"
                            hide-details style="width:60%;margin-left: 50px;color: black">
              </v-text-field>
            </div>
            <div style="border-bottom: 1px solid rgba(229,229,229,1)" class="mt-8"></div>
            <div v-show="fileType === 1">
              <div style="">
                <div style="height: 68px;width:100%;line-height: 80px;color: black">
                  <v-radio-group v-model="teamReadOnly">
                    <v-radio :value="0">
                      <template v-slot:label>
                        <div style="display: flex"
                             :style="{'color' : teamReadOnly === 0 ? 'black' : 'rgba(128,128,128,1)'}">
                          <span style="margin-top: 2px">团队文件中数据可新增</span>
                          <p style="margin-left: 60px">可新增数据，同时可编辑、删除本人创建的数据</p>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio style="margin-top: 10px" :value="1">
                      <template v-slot:label>
                        <div style="display: flex"
                             :style="{'color' : teamReadOnly === 1 ? 'black' : 'rgba(128,128,128,1)'}">
                          <span style="margin-top: 2px">团队文件只读</span>
                          <p style="margin-left: 123px">团队文件中所有的数据都不能由协作者进行编辑</p>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </div>
              </div>
              <div style="border-bottom: 1px solid rgba(229,229,229,1)" class="mt-4"></div>
              <el-checkbox v-model="teamExport" style="margin-left: 7px;">
                <div style="color: black;font-size: 16px;line-height: 50px;" class="ml-1">
                  允许团队协作者复制、导出团队文件
                </div>
              </el-checkbox>
              <div style="border-bottom: 1px solid rgba(229,229,229,1)"></div>
              <el-checkbox v-model="teamSave" style="margin-left: 7px;">
                <div style="color: black;font-size: 16px;line-height: 50px;" class="ml-1">
                  允许团队文件协作者保存团队附件到个人附件
                </div>
              </el-checkbox>
              <div style="border-bottom: 1px solid rgba(229,229,229,1)"></div>
              <el-checkbox v-model="teamInvite" style="margin-left: 7px;">
                <div style="color: black;font-size: 16px;line-height: 50px;" class="ml-1">
                  允许团队文件协作者邀请其他协作者
                </div>
              </el-checkbox>
            </div>
          </div>
          <div style="height: 64px; width: 100%;position: relative">
            <div @click="transferConfirm" class="confirm-btn">
              <p style="text-align: center;color: white">转换</p>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import LoadingDialog from "@/views/globe/dialog/file_manage/LoadingDialog.vue";
import axios from "axios";

export default {
  name: "TransferTeamFileDialog",
  components: {LoadingDialog},
  props: ["transferFileDialogShow", "originalFileName", "originalFileId"],
  data() {
    return {
      loadingText: '文件转换中......',
      transferDialogShow: false,
      transferLoadingCardShow: false,
      fileType: 1, // 个人0 团队1
      fileInfo: '',
      tempFileName: '',
      teamReadOnly: 0,// 0为可新增 1为只读
      teamExport: true, //允许导出为1
      teamSave: true, //允许保存为1
      teamInvite: true, //允许邀请为1
      cancelToken: '',
      source: '',
      maxFileNameCharacter: 30
    }
  },
  methods: {
    closeTransferDialog() {
      // this.transferFileDialogShow = false
      this.$emit('closeWholeTransferDialog')
    },
    closeLoadingDialog() {
      // 需要中止网络请求
      this.source.cancel()
      this.transferLoadingCardShow = false
      this.closeTransferDialog()
    },
    transferConfirm() {
      if (this.tempFileName === '') {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "团队文件名不能为空"
        this.$store.state.snackbarType = 'error'
        return
      }
      if (this.tempFileName.length > this.maxFileNameCharacter) {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "团队文件名过长(超过30字)"
        this.$store.state.snackbarType = 'error'
        return
      }
      let params = new FormData()
      params.append('fileId', this.originalFileId)
      params.append('fileName', this.tempFileName)
      params.append('teamReadonly', this.teamReadOnly)
      params.append('teamExport', this.teamExport ? '1' : '0')
      params.append('teamSave', this.teamSave ? '1' : '0')
      params.append('teamInvite', this.teamInvite ? '1' : '0')
      this.transferLoadingCardShow = true
      this.cancelToken = axios.CancelToken
      this.source = this.cancelToken.source()
      axios({
        method: 'post',
        url: '/authorApi/z-geo-file/transformFile',
        data: params,
      }, {
        cancelToken: this.source
      }).then((resp) => {
        resp = resp['data']
        if (resp['status'] === 200) {
          this.transferLoadingCardShow = false
          this.closeTransferDialog()
          this.$emit('searchInputEnter')
          this.$store.state.snackbarShow = true
          this.$store.state.snackbarText = "文件转换成功"
          this.$store.state.snackbarType = 'success'
        } else {
          console.log('message = ' + resp['message'] + ' status = ' + resp['status'])
        }
      })
    }
  },
  mounted() {
    this.tempFileName = this.originalFileName
    this.fileType = 1
    this.teamReadOnly = 0
    this.teamExport = true
    this.teamSave = true
    this.teamInvite = true
  }
}
</script>

<style scoped>
.new-icon {
  background: red;
  width: 28px;
  height: 12px;
  font-size: 8px;
  color: white;
  line-height: 12px;
  text-align: center;
  border-radius: 14px 6px 14px 0;
  margin-left: 3px;
  margin-top: -2px
}

.confirm-btn {
  position: absolute;
  right: 30px;
  bottom: 14px;
  height: 35px;
  line-height: 35px;
  width: 100px;
  background: rgba(30, 58, 138, 1);
  cursor: pointer;
}

.disable-checkbox :deep(.theme--light.v-icon) {
  color: rgba(196, 196, 196, 1);
}

:deep(.el-tree-node__content) {
  border-bottom: 1px solid rgba(229, 229, 229, 1);
  border-top: 1px solid transparent;
}

:deep(.el-tree-node__content):hover {
  background-color: rgba(42, 130, 228, 0.1) !important;
  border-top: none !important;
  border-bottom: none !important;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background-color: rgba(41, 122, 255, 1);
  border-color: rgba(41, 122, 255, 1);
}

:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  background-color: rgba(41, 122, 255, 1);
  border-color: rgba(41, 122, 255, 1);
}

::-webkit-scrollbar {
  display: none;
}
</style>